import { Component, Input } from '@angular/core';
import { OfflineDebateSessionQuestionAnswer } from '../../../../core/models/debates/offline-debates/offline-debate-session-question-answer';

@Component({
    selector: 'app-offline-debates-session-question-answers',
    templateUrl: './offline-debates-session-question-answers.component.html',
    styleUrls: ['./offline-debates-session-question-answers.component.css']
})
export class OfflineDebatesSessionQuestionAnswersComponent {
    private _questionAnswers: Array<OfflineDebateSessionQuestionAnswer>;
    @Input() set questionAnswers(value: Array<OfflineDebateSessionQuestionAnswer>) {
        this._questionAnswers = value;
        this.setDisplayedQuestionAnswers();
    }
    get questionAnswers() {
        return this._questionAnswers;
    }

    displayedQuestionAnswers: Array<OfflineDebateSessionQuestionAnswer>;
    public offset: number = 0;
    public limit: number = 5;
    public size: number = 0;
    public pageNum: number = 1;
    public pageSize: number = this.limit;
    public isDesc: boolean = true;
    public column: string = "";

    onLimitChange(newLimit: number) {
        this.offset = 0;
        this.limit = newLimit;
        this.pageNum = 1;
        this.pageSize = +newLimit;
        this.setDisplayedQuestionAnswers();
    }

    onPageChange(offset: number) {
        this.offset = offset;
        this.pageNum = Math.floor(offset / this.limit) + 1;
        this.setDisplayedQuestionAnswers();
    }

    setDisplayedQuestionAnswers() {
        const questionAnswersForDisplay = this.questionAnswers && this.questionAnswers.length > 0 ? this.questionAnswers : [];
        if (this.pageNum > 1 && (this.pageNum - 1) * this.pageSize >= questionAnswersForDisplay.length) {
            this.pageNum = this.pageNum - 1;
            this.offset = (this.pageNum - 1) * this.pageSize;
        }
        if (questionAnswersForDisplay.length > 0) {
            const skip = (this.pageNum - 1) * this.pageSize;
            this.displayedQuestionAnswers = [];
            if (questionAnswersForDisplay.length > skip) {
                const take = questionAnswersForDisplay.length > skip + this.pageSize ? skip + this.pageSize : questionAnswersForDisplay.length;
                for (let i = skip; i < take; i++) {
                    this.displayedQuestionAnswers.push(questionAnswersForDisplay[i]);
                }
            }
            this.size = questionAnswersForDisplay.length;
        } else {
            this.displayedQuestionAnswers = [];
        }
    }

}
